export const fetchGeom = async (geoserverUrl, layerName, variable, option) => {

    if (geoserverUrl && layerName && variable && option) {      
    const url = `${geoserverUrl}?service=WFS&version=2.0.0&request=GetFeature&typeName=${layerName}&outputFormat=application/json&propertyName=wkb_geometry&CQL_FILTER=${variable}=%27${option}%27`;
    const response = await fetch(url);
    const data = await response.json();
    const coordinates = data.features[0].geometry.coordinates;
    return(coordinates);
    }
    else {
        return ''
    }
  };